import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';
import { PercentChangeIndicator } from '../../../common/components';
import DashboardTooltip from '../utils/DashboardTooltip';
import { currencyFormatter, currencyFormatterInShort } from '../utils/dashboardConstants';
import NoData from '../utils/no-data';
import DashboardCardLayout from './layout';

function Collections({ data }) {
  return (
    <table className="collections-table">
      <tbody>
        {data.map((row) => (
          <tr key={row.paymentMode.replace(' ', '')} className="collection-type">
            <td className="collection-mode-account" width="50%">
              <p className="collection-mode">{row.paymentMode}</p>
              {row.accountNumber ? (
                <p className="collection-account">Account No. {row.accountNumber}</p>
              ) : null}
            </td>
            <td className="collection-total-value">
              <DashboardTooltip
                id={uniqueId('collections-mode')}
                position="bottom"
                value={row.amount}
                label={currencyFormatterInShort(row.amount)}
                tooltipText={currencyFormatter(row.amount)}
              />
            </td>
            <td className="collection-percent">
              <PercentChangeIndicator percent={row.percent} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

Collections.propTypes = {
  data: PropTypes.shape([]).isRequired,
};

function CollectionsCard({ data, bgColor, loader }) {
  return (
    <DashboardCardLayout
      title="Collections"
      tooltip="This chart will show the amount of Total Receipts divided into different payment types"
      cardTitle="Total Amount"
      options={{ bgColor }}
      data={data}
      className="collections-card top-tooltip"
      loader={loader}
    >
      {data.data.length > 0 ? <Collections data={data.data} /> : <NoData />}
    </DashboardCardLayout>
  );
}

CollectionsCard.propTypes = {
  bgColor: PropTypes.string.isRequired,
  loader: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    data: PropTypes.array,
  }).isRequired,
};

export default CollectionsCard;
